import { z } from 'zod';
import { createWithdrawAmountSchema } from '@/entities/operation';
import type { WithdrawSbpFormValues } from './types';

export const createWithdrawSbpFormSchema = (
  minWithdraw?: number,
  maxAvailable?: number,
  totalAmount?: number,
  phoneError?: string,
  maxWithdraw?: number,
  maxWithdrawMessage?: string
) => {
  return z.object({
    currencyCode: z.string().nonempty({ message: '' }),
    phoneNumber: z
      .string()
      .nonempty({ message: '' })
      .refine(
        val => {
          if (!val) return false;
          return val.startsWith('+7');
        },
        {
          message: phoneError || '',
        }
      ),
    bankId: z.string().nonempty({ message: '' }),
    amount: createWithdrawAmountSchema({
      minWithdraw,
      maxAvailable,
      requireMaxAvailable: true,
      totalAmount,
      maxWithdraw,
      maxWithdrawMessage,
    }),
    includeFee: z.boolean().default(false),
  }) satisfies z.ZodType<WithdrawSbpFormValues>;
};
